module.exports = __webpack_public_path__ + "assets/sqh2-ico-pickdate.df070809.svg";